/**
 * 取引先
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/suppliers`

 const master_search_supplier = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 取引先を取得する
     * @param commit
     * @param id { number } 取引先ID
     * @param type { string } 取引先種別(Emission or Trader)
     * @return {Promise<unknown>}
     */
    show ({ commit }, { id, type }) {
      const params = { id: id, type: type }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
 }
 export default master_search_supplier
